/* eslint-disable react/no-array-index-key */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { CircularProgress, Grid, Paper, TextField } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import Question from "./Question";
import { QuestionsContext } from "../../Context/questionsContext";
import { postData } from "../../Services/postData";
import { LocalUrlEnum, UrlEnum } from "../../Utils/Utils";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { getData } from "../../Services/getData";
import QuestionnaireMenu from "./QuestionnaireMenu";
import { BreadCrumbsContext } from "../../Context/breadCrumbsContext";
import { Vocabulary } from "../../Utils/Vocabulary";
import style from "./Questionnaire.module.scss";
import { breadCrumbsEnum } from "../../Utils/Constants";

export default function Questionnaire() {
  const questionsContext = useContext(QuestionsContext);
  const breadCrumbsContext = useContext(BreadCrumbsContext);
  const [questionnaire, setQuestionnaire] = useState({
    id: "0",
    questionnaireName: "",
  });
  const notifyError = (message: string) => toast.error(message);
  const notifySuccess = (message: string) => toast.success(message);
  const [loading, setLoading] = useState(false);
  const [openAddTemplate, setOpenAddTemplate] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const userName = localStorage.getItem("userName")
    ? localStorage.getItem("userName")
    : "";

  useEffect(() => {
    let id = location.pathname;
    id = id.replace("/questionnaires/", "");
    if (id === "0") {
      breadCrumbsContext.setBreadCrumbs([
        `${breadCrumbsEnum.questionnaires}`,
        `${Vocabulary.newQuestionnaire}`,
      ]);
    }
    if (id !== "0" && questionnaire.questionnaireName === "") {
      getQuestionnaire(id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /**
   *
   * @param item
   */
  function updateLocalQuestionnaire(item: any) {
    const newQuestionnaire = {
      id: item._id,
      questionnaireName: item.questionnaireName,
    };
    breadCrumbsContext.setBreadCrumbs([
      `${breadCrumbsEnum.questionnaires}`,
      `${newQuestionnaire.questionnaireName}`,
    ]);
    setQuestionnaire(newQuestionnaire);
    questionsContext.setQuestions(item.questions);
  }

  /**
   *
   * @param id
   */
  async function getQuestionnaire(id: string) {
    setLoading(true);
    getData(`${UrlEnum.questionnaire}/${id}`)
      .then((res) => {
        if (res && res.data && res.data.length > 0) {
          updateLocalQuestionnaire(res.data[0]);
        }
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        notifyError(Vocabulary.getError);
      });
  }

  /**
   *
   */
  function handleChangeOpenAddTemplate() {
    setOpenAddTemplate(!openAddTemplate);
  }
  /**
   *
   */
  function saveQuestionnaires(event: any) {
    event.preventDefault();
    setLoading(true);
    const newQuestions = questionsContext.questions.map((question) => ({
      answers: question.answers,
      answerType: question.answerType,
      images: question.images ? question.images : [],
      openCollapse: question.openCollapse,
      question: question.question,
      minValue: question.minValue,
      maxValue: question.maxValue,
    }));
    const newQuestionnaire = {
      questionnaireName: questionnaire.questionnaireName,
      questions: newQuestions,
      userName: userName,
    };
    let url = UrlEnum.questionnaire;
    if (questionnaire.id !== "0") {
      url = `${UrlEnum.questionnaire}/${questionnaire.id}`;
    }
    postData(url, newQuestionnaire)
      .then((res) => {
        if (questionnaire.id === "0") {
          navigate(`${LocalUrlEnum.questionnaires}${res.data._id}`);
        }
        if (res && res.data) {
          updateLocalQuestionnaire(res.data);
        }
        notifySuccess(Vocabulary.saveSuccess);
        setLoading(false);
      })
      .catch((err) => {
        notifyError(Vocabulary.saveError);
        setLoading(false);
      });
  }

  /**
   *
   * @param templateName
   */
  function saveAsTemplate(templateName: string) {
    setLoading(true);
    const template = {
      templateName: templateName,
      questions: questionsContext.questions,
      userName: userName,
    };
    postData(UrlEnum.questionnaireTemplates, template)
      .then((res) => {
        handleChangeOpenAddTemplate();
        notifySuccess(Vocabulary.saveSuccess);
        setLoading(false);
      })
      .catch((err) => {
        handleChangeOpenAddTemplate();
        notifyError(Vocabulary.saveError);
        setLoading(false);
      });
  }

  return (
    <>
      <form onSubmit={saveQuestionnaires}>
        <Grid container spacing={2} style={{ marginRight: 0 }}>
          <QuestionnaireMenu
            isQuestionnaireTemplate={false}
            openAddTemplate={openAddTemplate}
            questionnaireName={questionnaire.questionnaireName}
            saveAsTemplate={saveAsTemplate}
            handleChangeOpenAddTemplate={handleChangeOpenAddTemplate}
          />
          <Grid item xs={10} className={style.questionnaireContainer}>
            <Paper className={style.questionnaireContainerPaper}>
              <TextField
                type="text"
                name="questionnaireName"
                label={Vocabulary.questionnaireName}
                variant="standard"
                value={questionnaire.questionnaireName}
                onChange={(e) =>
                  setQuestionnaire({
                    ...questionnaire,
                    questionnaireName: e.target.value,
                  })
                }
                required
                fullWidth
              />
            </Paper>
            {questionsContext.questions.map((question, index) => (
              <Paper
                key={`questionsContext${index}`}
                className={style.question}
              >
                <Question
                  questionNumber={index}
                  questions={questionsContext.questions}
                  saveQuestionnaires={(e: any) => saveQuestionnaires(e)}
                />
              </Paper>
            ))}
          </Grid>
        </Grid>
      </form>
      {loading ? (
        <div className="loading">
          <CircularProgress color="primary" />
        </div>
      ) : (
        ""
      )}
    </>
  );
}
